<template>
  <div v-if="isPopUp" class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <span id="armor_close" name="armor_close" class="armor-close" @click="close"></span>
        <div class="modalBox-title_armor">{{ $t("netgear_armor") }}</div>
      </div>
      <div class="modalBox-logo"></div>
      <div class="modal-body-armor">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <p class="armor-tip1" v-html="$t('armor_str1')"></p>
        <p v-if="armor_accredit_type === 'trail'" class="armor-tip2" v-html="$t('armor_str2')" />
        <!-- eslint-disable-next-line vue/no-v-html -->
        <p v-else class="armor-tip2" v-html="$t('armor_str3')" />
        <div id="armor_app" class="modalButton-armor-QR" name="armor_app">
          <img src="~images/armor/armor_QR.png" />
          <span v-if="$store.state.page.type == 'orbi'">
            <p>{{ $t("scan_orbi_app") }}</p>
          <span v-else>
            <p>{{ $t("scan_nighthawk_app") }}</p>
          </span>
        </div>
        <div
          v-if="!jumpDone"
          id="armor_nvrm"
          class="modalButton-armor"
          name="armor_nvrm"
          @click="neverRemind"
        >
          {{ $t("never_remind") }}
        </div>
        <div v-else id="armor_done" class="modalButton-armor-done">
          <img src="~images/armor/armor_updated.png" />
          {{ $t("prefer_update") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      armor_accredit_type: "trail",
      jumpDone: false,
      isPopUp: false,
    };
  },
  async mounted() {
    this.isPopUp = await this.$store.dispatch("user/getArmor");
    this.armor_accredit_type = await this.$store.dispatch("user/getArmorInfo");
  },
  methods: {
    async neverRemind() {
      await this.$store.dispatch("user/setArmor", false);
      const ret = await this.$api.post("armor", { never_remind: 1 });
      if (ret) {
        this.jumpDone = true;
      }
    },
    async close() {
      this.isPopUp = false;
      await this.$store.dispatch("user/setArmor", false);
    },
  },
};
</script>
<style lang="scss">
@import "~@/styles/variables.scss";
.modal {
  position: fixed;
  z-index: 10000;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.4);
}
.modal-content {
  position: relative;
  padding: 16px;
  margin: auto;
  border: 1px solid #888;
  width: 40%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  min-height: 524px;
  min-width: 576px;
  background: url("~images/armor/armor_Background.png") no-repeat;
  background-size: cover;
}
.modal-header {
  padding: 2px 0;
  color: #fff;
}
.armor-close {
  width: 25px;
  height: 25px;
  border: 1px;
  float: right;
  background: url("~images/armor/armor_close.png") no-repeat center;
}
.armor-close:focus,
.armor-close:hover {
  border-radius: 2px;
  background-color: rgba(255, 255, 255, 0.09);
}
.modalBox-title_armor {
  color: #fff;
  font-size: 21px;
  text-align: center;
  font-family: Avenir-Book;
  margin-top: 45px;
}
.modalBox-logo {
  margin-top: 20px;
  margin-bottom: 5px;
  width: 100%;
  height: 101px;
  background: url("~images/armor/armor_white.png") no-repeat center;
}
.modal-body-armor {
  padding: 2px 0;
  color: #fff;
  font-family: Avenir-Medium;
  text-align: center;
  .armor-tip1 {
    font-size: 16px;
    letter-spacing: -0.53px;
  }
  .armor-tip2 {
    font-size: 11px;
    letter-spacing: -0.37px;
  }
}
.modalButton-armor-QR {
  font-size: 12px;
  color: #fff;
  letter-spacing: -0.4px;
  text-align: center;
  img {
    width: 62px;
    height: 62.76px;
  }
}
.modalButton-armor {
  width: 60%;
  border-radius: 5px;
  height: 50px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  line-height: 51px;
  margin-top: 10px;
  margin-bottom: 40px;
  cursor: pointer;
  font-family: Avenir-Book;
  font-size: 14px;
  color: #94c2d9;
  letter-spacing: -0.47px;
}
.modalButton-armor:focus,
.modalButton-armor:hover {
  background-color: rgba(255, 255, 255, 0.09);
  color: #81b5d0;
  border-radius: 2px;
}
.modalButton-armor-done {
  width: 60%;
  border-radius: 5px;
  height: 50px;
  margin-left: auto;
  margin-right: auto;
  line-height: 51px;
  margin-top: 10px;
  margin-bottom: 40px;
  font-family: Avenir-Book;
  font-size: 14px;
  color: #fff;
  letter-spacing: -0.47px;
  text-align: center;
  img {
    width: 16px;
    height: 16px;
    color: #ffffff;
    margin-right: 8px;
    vertical-align: middle;
  }
}
</style>
